<!-- Mounted on all app routes so header + / LPR / checkout work outside Orders; Pusher auto-popup stays orders-only in app.component.ts -->
<app-impersonation-banner></app-impersonation-banner>
<app-notification-modal *ngIf="!isPublicStreamRoute && !isTunnelRoute"></app-notification-modal>
<app-way-purchase-modal *ngIf="!isPublicStreamRoute && !isTunnelRoute"></app-way-purchase-modal>
<app-multi-eligible-selection-modal
  *ngIf="!isPublicStreamRoute && !isTunnelRoute"
></app-multi-eligible-selection-modal>
<app-lane-attention-stack *ngIf="!isPublicStreamRoute && !isTunnelRoute"></app-lane-attention-stack>
<app-lane-auto-redeem-toast
  *ngIf="!isPublicStreamRoute && !isTunnelRoute"
></app-lane-auto-redeem-toast>
<!-- CWS-1908: opens on its own when a scanned prepaid QR cannot be resolved; the typed code opens the same flow the QR would have. -->
<app-prepaid-code-dialog
  *ngIf="!isPublicStreamRoute && !isTunnelRoute"
  [isOpen]="isPrepaidCodeDialogOpen"
  [busy]="prepaidCodeBusy"
  [error]="prepaidCodeError"
  [intro]="prepaidCodeIntro"
  (find)="onPrepaidCodeFind($event)"
  (closed)="closePrepaidCodeDialog()"
></app-prepaid-code-dialog>
<router-outlet></router-outlet>

<!-- Toast surface for the whole app (login and public routes included). -->
<app-toast-container></app-toast-container>

<!-- Custom body for the sticky deploy toast raised by DeploymentNotificationService. -->
<ng-template appToastTemplate="deployment-update" let-message>
  <div class="deployment-toast">
    <div class="deployment-toast__title">
      <span>{{ message.summary }}</span>
    </div>
    <p class="deployment-toast__detail">{{ message.detail }}</p>
    <button type="button" class="deployment-toast__reload" (click)="onDeploymentReload()">
      {{ message.data?.linkLabel || 'Reload Now' }}
    </button>
  </div>
</ng-template>
